// ** Third Party Components
import styled from "styled-components";

// #####################################################

export const StyledHeadingWrapper = styled.div`
	padding: 0 0 0.5rem 0;
`;

// #####################################################
